import { AppKitButton } from "@reown/appkit/react";
import Button from "./Button";
import { ButtonTheme } from "./ButtonTheme";
import { isMiniApp } from "../../utils/Constants";

/**
 * @param onSectionSelect - Function to select a section
 */
export interface FloatingProps {
  /**
   * @description Callback to when the previous draw button is clicked.
   */
  onPreviousDraw?: () => void;
  /**
   * @description Whether a wallet is currently connected or not.
   */
  isConnected: boolean;
  /**
   * @description Callback to when the ConnectWallet button is clicked.
   */
  connectWallet: () => Promise<void>;
}

/**
 * @description Floating component. Contains everything that is persistently on the screen.
 */

export default function Floating(props: FloatingProps) {
  return (
    <div className="fixed bottom-0 left-0 z-30 flex flex-col items-end ~ml-3.5/5 ~mb-4/5.5">
      {/* Button to show previous draw */}
      {/* {props.onPreviousDraw != undefined && (
        <button
          onClick={props.onPreviousDraw}
          className="rounded-lg bg-bastille ~p-2/2.5 ~mb-2/2.5 bg-cinder/50 transition hover:ease-in-out hover:delay-100 hover:bg-bastille hover:scale-105 duration-250"
        >
          <div className="flex flex-row items-center">
            <span className="font-archb text-silver ~text-xs/base">
              LAST DRAW
            </span>
          </div>
        </button>
      )} */}
      {/* Button to connect wallet */}
      {!isMiniApp && (
        <div className="fixed bottom-0 top-auto sm:top-0 sm:bottom-auto right-0 z-30 ~mr-3.5/5 ~my-4/5.5 rounded-full transition hover:ease-in-out hover:delay-100 hover:scale-105 duration-250">
          {props.isConnected ? (
            <AppKitButton balance="hide" />
          ) : (
            <Button
              theme={ButtonTheme.PersianPink}
              loading={false}
              onClick={() => props.connectWallet()}
              enabled={true}
              text={"CONNECT"}
            />
          )}
        </div>
      )}
    </div>
  );
}
